import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import GIF from "gif.js.optimized";
import { avatarBaseUrl } from "../../data/endpointData";
import { LoadingSpinner } from "../../components/compIndex";
import { avatarMap } from "../../data/avatarMap";

const Avatars = () => {
  const [avatars, setAvatars] = useState([]);
  const [selectedAvatar, setSelectedAvatar] = useState("");
  const [tokenNum, setTokenNum] = useState("");
  const [error, setError] = useState("");
  const [gifs, setGifs] = useState({});
  const [combinedImageUrl, setCombinedImageUrl] = useState("");
  const [avatarInfo, setAvatarInfo] = useState("");
  const [blockchainFilter, setBlockchainFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const [refetching, setRefetch] = useState(false);
  const [downloadLinks, setDownloadLinks] = useState("");

  const recentAvatars = avatars.slice(-4);
  const avatarNames = recentAvatars
    .map((avatar) => {
      return avatar.customName || avatarMap.find((a) => a.id === avatar.id)?.customName || avatar.id;
    })
    .join(", ");

  const handleGenerateClick = async (event) => {
    event.preventDefault();

    if (!selectedAvatar || !tokenNum) {
      setAvatarInfo(null);
      setGifs({});
      setCombinedImageUrl("");
      setRefetch(false);
      setLoading(true);
      setError("Please select an avatar and enter a token number");
      return;
    }

    setLoading(true);
    setAvatarInfo(null);
    setGifs({});
    setCombinedImageUrl("");
    setError("");
    setRefetch(false);

    try {
      const avatar = avatars.find((av) => av._id === selectedAvatar._id);
      await fetchTraits(avatar,tokenNum);
    } catch (err) {
      setError("Couldn't get that avatar's traits.");
      setLoading(false);
      console.error(err);
    }
  };

  const shortenAddress = (address) => {
    if (address.length <= 10) return address;
    return `${address.substring(0, 5)}...${address.substring(address.length - 5)}`;
  };

  const fetchTraits = async (avatar, tokenNum) => {
    let searchChain = avatar.chain;
    let searchContract = avatar.contractAddress;
    let traits = {};

    try {
      try {
        const response = await fetch(`https://api.pixelore.wiki/api/traits?chain=${searchChain}&contractAddress=${searchContract}&tokenNum=${tokenNum}`);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        const nftInfo = data.nft;

        let owner, ownerUrl, description;
        if (nftInfo.owners && nftInfo.owners.length > 0) {
          owner = nftInfo.owners[0].address.toLowerCase();
          ownerUrl = `https://opensea.io/${owner}`;
          description = nftInfo.description;
        } else {
          owner = "N/A";
          ownerUrl = "none";
          description = "No description from this one ( ｡ •̀ ᴖ •́ ｡) Y NO DESCRIPTION";
        }

        const network = avatar.chain;
        const contract = avatar.contractAddress.toLowerCase() || "N/A";
        const nftImage = nftInfo.display_image_url || "";
        const shortenedContract = shortenAddress(contract);
        const shortenedOwner = shortenAddress(owner);

        const combinedAvatarInfo = `<center><img src="${nftImage}" height="100" width="100"/></center><br/><strong>Chain:</strong> ${
          blockchainOptions.find((option) => option.value === network)?.label
        }<br><strong>Contract Address:</strong> <a className="myLinks" href="https://opensea.io/assets/${searchChain}/${contract}/${tokenNum}" target="_blank" rel="noreferrer">${shortenedContract}</a><br><strong>Current Owner:</strong> <a href="${ownerUrl}" target="_blank" rel="noreferrer">${shortenedOwner}</a><br><strong>NFT Description: </strong>${description}`;
        setAvatarInfo(combinedAvatarInfo);
        console.log(combinedAvatarInfo);

        const traitsArray = nftInfo.traits || []; // Build traits object

        traits = traitsArray.reduce((acc, trait) => {
          if (trait.value) {
            const value =
              typeof trait.value === "string"
                ? trait.value
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "")
                    .replace(/\s+/g, "")
                : String(trait.value)
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "")
                    .replace(/\s+/g, "");
            const traitType = trait.trait_type
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "")
              .replace(/\s+/g, "");
            acc[traitType] = value;
          }
          return acc;
        }, {});
      } catch (error) {
        console.log("No Data to Display for this NFT: ", error);
        const combinedAvatarInfo = `No data to display for this NFT`;
        setAvatarInfo(combinedAvatarInfo);
      }

      const specialTraits = specialTraitMappings[avatar.id] || {};
      Object.assign(traits, specialTraits);

      let imageUrls = getImageUrls(avatar, traits);
      if (imageUrls.length > 0) {
        await combineAndDisplaySpritesheets(imageUrls, avatar, traits);
      } else {
        imageUrls = refetchImagesWithDefault(avatar, traits);
        if (imageUrls.length > 0) {
          await combineAndDisplaySpritesheets(imageUrls, avatar, traits);
        } else {
          console.warn("No image URLs found for the given traits.");
          setError("Couldn't load images from Pixels, sorry.");
        }
      }
    } catch (err) {
      setLoading(false);
      console.error("Error fetching Avatar traits:", err);
      setError("Couldn't find traits for that token ID. Are you sure that's the correct token number?");
    }
  };

  const refetchImagesWithDefault = (avatar, traits) => {
    try {
      setRefetch(true);
      const defaultTraits = defaultTraitMapping[avatar.id] || {};
      Object.assign(traits, defaultTraits);
      const imageUrls = getImageUrls(avatar, traits);
      return imageUrls;
    } catch (error) {
      console.log("Failed to Refetch traits: ", error);
      setLoading(false);
    }
  };

  const specialTraitMappings = {
    angrydynomitesfire: {
      full: "default",
    },
    angrydynomiteswater: {
      full: "default",
    },
    arteezzykool: {
      arteezzykool: "arteezzykool",
    },
    chimpers: {
      full: tokenNum,
    },
    chimpersgenesis: {
      full: tokenNum,
    },
    chimperstraining: {
      tokenid: tokenNum,
    },
    cryptokitty: {
      cryptokitty: "cryptokitty",
    },
    cryptomasks: {
      body: "body",
    },
    deadfellaz: {
      tokenid: tokenNum,
    },
    dizzy: {
      fold: "default",
    },
    ethlizardlocked: {
      tokenid: tokenNum,
    },
    ethlizardventure: {
      tokenid: tokenNum,
    },
    ethlizardgenesis: {
      tokenid: tokenNum,
    },
    falarmonkey: {
      falarmonkey: "falarmonkey",
    },
    fightleague: {
      fightleague: "fightleague",
    },
    fortuneronin: {
      fortuneronin: "fortuneronin",
    },
    foxfam: {
      "1of1": tokenNum,
    },
    galacticapes: {
      avatar: tokenNum,
    },
    gam3s: {
      gam3s: "gam3s",
    },
    glizzygang: {
      base: "mainglizzy",
    },
    jihoz: {
      full: "avatarjihoz",
    },
    kongz: {
      full: tokenNum,
    },
    kongzronin: {
      full: tokenNum,
    },
    kongzvxeth: {
      tokenid: tokenNum,
    },
    kongzvxronin: {
      tokenid: tokenNum,
    },
    kittyinu: {
      kittyinu: "kittyinu",
    },
    machinearena: {
      machinearena: "machinearena",
    },
    mastercat: {
      full: "default",
    },
    moki: {
      tokenid: tokenNum,
    },
    moonbirds: {
      full: tokenNum,
    },
    nyancat: {
      tokenid: tokenNum,
    },
    nyancatballoon: {
      tokenid: tokenNum,
    },
    pixeldragons: {
      tokenid: tokenNum,
    },
    pixelkittens: {
      tokenid: tokenNum,
    },
    pixelmon: {
      pixelmon: "pixelmon",
    },
    pixelmontrainers: {
      pixelmon: "pixelmon",
    },
    playember: {
      playember: "playember",
    },
    ronke: {
      ronke: "ronke",
    },
    roninchibis: {
      tokenid: tokenNum,
    },
    thebibiz: {
      avatar: tokenNum,
    },
    thelittles: {
      thelittles: "thelittles",
    },
    squishiverse: {
      tokenid: tokenNum,
    },
    tribestersnexus: {
      tribestersnexus: "tribestersnexus",
    },
    tribesters: {
      tier: "common",
    },
  };

  const defaultTraitMapping = {
    llamaverse: {
      arms: "gold",
      skin: "gold",
      mouth: "straight",
      eyes: "redeyes",
      headgear: "crown",
    },
    kongzronin: {
      full: "default",
    },
    zenapes: {
      skin: "purple",
      face: "derp2",
    },
  };

  const specialTraits = ["oneofone", "1/1", "1of1", "11", "typetrait", "rug"];

  const getPossibleVariations = (trait) => {
    // Define possible variations for the trait
    const variations = {
      oneofone: ["oneofone", "1/1", "1of1", "11"],
      "1/1": ["oneofone", "1/1", "1of1", "11"],
      "1of1": ["oneofone", "1/1", "1of1", "11"],
      11: ["oneofone", "1/1", "1of1", "11"],
      typetrait: ["type", "typetrait"],
      rug: ["rugs"],
    };

    // Standardize and return variations for the given trait
    const standardizedTrait = trait.toLowerCase().replace(/\s+/g, "");
    return variations[standardizedTrait] || [standardizedTrait];
  };

  const getImageUrls = (avatar, traits) => {
    return avatar.pieces
      .map((piece) => {
        let urlTemplate = ""; // Accumulate the URL template
        let valid = true; // To check if trait value is valid

        if (piece.url && piece.url.override) {
          piece.url.override.forEach((item) => {
            if (item.attribute) {
              const attribute = item.attribute.toLowerCase().replace(/\s+/g, "");
              let traitValue;
              if (specialTraits.includes(attribute)) {
                // Apply variation logic only for special traits
                const possibleVariations = getPossibleVariations(attribute);
                traitValue = possibleVariations.map((variation) => traits[variation]).find((value) => value !== undefined);
              } else {
                // Standard lookup for other traits
                traitValue = traits[attribute];
              }

              if (traitValue !== undefined) {
                if (avatar.id === "pixelBeasts" && attribute !== "beast") {
                  urlTemplate += "/" + traitValue;
                  valid = true;
                } else {
                  urlTemplate += traitValue; // Append trait value
                }
              } else {
                valid = false; // Invalid trait value
              }
            } else if (item.text) {
              if (avatar.id === "pixelBeasts" && item.text === "/") {
                urlTemplate += "regular";
              } else {
                urlTemplate += item.text; // Append static text
              }
            }
          });

          if (valid) {
            return `${avatarBaseUrl}${avatar.id}${urlTemplate}`;
          }
        } else if (piece.attributes) {
          const traitId = piece.attributes[0]?.id?.toLowerCase().replace(/\s+/g, "");
          let traitValue;

          if (specialTraits.includes(traitId)) {
            // Apply variation logic only for special traits
            const possibleVariations = getPossibleVariations(traitId);
            traitValue = possibleVariations.map((variation) => traits[variation]).find((value) => value !== undefined);
          } else {
            // Standard lookup for other traits
            traitValue = traits[traitId];
          }

          if (traitValue !== undefined) {
            return `${avatarBaseUrl}${avatar.id}/${piece.id}/${traitValue}.png`;
          }
        }

        return undefined;
      })
      .filter(Boolean);
  };

  const combineAndDisplaySpritesheets = async (imageUrls, avatar, traits) => {
    const { width: frameWidth, height: frameHeight } = avatar.sprite.size;
    const numFrames = avatar.sprite.frames;

    // Load images
    const images = await Promise.all(
      imageUrls.map((url) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = url;
          img.onload = () => resolve(img);
          img.onerror = (err) => reject(`Error loading ${url}: ${err}`);
        }).catch((err) => {
          console.warn(err);
          return null;
        })
      )
    );

    // Filter out failed images
    const validImages = images.filter((img) => img);
    if (validImages.length === 0) {
      console.warn("No valid images, attempting refetch...");
      setRefetch(true);
      const newImageUrls = await refetchImagesWithDefault(avatar, traits);
      if (newImageUrls.length > 0) return combineAndDisplaySpritesheets(newImageUrls, avatar, traits);
      setError("No valid images to display.");
      setLoading(false);
      return;
    }

    // Calculate canvas size
    const canvasWidth = Math.floor(validImages[0].width / frameWidth) * frameWidth;
    const canvasHeight = Math.ceil(numFrames / (canvasWidth / frameWidth)) * frameHeight;

    // Create canvas with transparent background
    const spriteCanvas = document.createElement("canvas");
    spriteCanvas.width = canvasWidth;
    spriteCanvas.height = canvasHeight;
    const spriteCtx = spriteCanvas.getContext("2d");
    spriteCtx.clearRect(0, 0, canvasWidth, canvasHeight);

    validImages.forEach((img) => {
      for (let i = 0; i < numFrames; i++) {
        const sx = (i % (canvasWidth / frameWidth)) * frameWidth;
        const sy = Math.floor(i / (canvasWidth / frameWidth)) * frameHeight;
        spriteCtx.drawImage(img, sx, sy, frameWidth, frameHeight, sx, sy, frameWidth, frameHeight);
      }
    });

    if (validImages.length === 0 && refetching) {
      setRefetch(true);
      const newImageUrls = await refetchImagesWithDefault(avatar, traits);
      if (newImageUrls.length > 0) {
        await combineAndDisplaySpritesheets(newImageUrls, avatar, traits);
      } else {
        console.warn("No valid images to process.");
        setError("There's nothing to display for the token requested.");
        setLoading(false);
        return;
      }
    }

    // Extract first frame preview
    const firstFrameCanvas = document.createElement("canvas");
    firstFrameCanvas.width = frameWidth;
    firstFrameCanvas.height = frameHeight;
    const firstFrameCtx = firstFrameCanvas.getContext("2d");
    firstFrameCtx.drawImage(spriteCanvas, 0, 0, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);
    setCombinedImageUrl(firstFrameCanvas.toDataURL("image/png"));

    // Create GIF
    const createGif = async (name, anim) => {
      return new Promise((resolve, reject) => {
        const gif = new GIF({
          workers: 2,
          quality: 10,
          width: frameWidth,
          height: frameHeight,
          workerScript: process.env.PUBLIC_URL + "/gif.worker.js",
          repeat: 0,
          transparent: true,
          globalPalette: false,
        });

        for (let i = anim.start; i <= anim.end; i++) {
          const frameCanvas = document.createElement("canvas");
          frameCanvas.width = frameWidth;
          frameCanvas.height = frameHeight;
          const frameCtx = frameCanvas.getContext("2d");
          const sx = (i % (canvasWidth / frameWidth)) * frameWidth;
          const sy = Math.floor(i / (canvasWidth / frameWidth)) * frameHeight;
          frameCtx.drawImage(spriteCanvas, sx, sy, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);

          // Check if frame is blank
          if (!isBlankFrame(frameCanvas)) {
            gif.addFrame(frameCanvas, { delay: 600 / anim.frameRate });
          }
        }

        gif.on("finished", (blob) => {
          const gifUrl = URL.createObjectURL(blob);
          setLoading(false);
          setTimeout(() => URL.revokeObjectURL(gifUrl), 10000);
          resolve({ [name]: gifUrl });
        });

        gif.on("error", (err) => reject(`GIF creation error: ${err}`));
        gif.render();
      });
    };

    const isBlankFrame = (canvas) => {
      const ctx = canvas.getContext("2d");
      const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      return !data.some((_, i) => i % 4 === 3 && data[i] > 0); // Check alpha values
    };

    try {
      const gifResults = await Promise.all(Object.entries(avatar.animations).map(([name, anim]) => createGif(name, anim)));
      setGifs(Object.assign({}, ...gifResults));
    } catch (err) {
      console.error("Error creating GIFs:", err);
    }
  };

  const idsToExcludeOld = new Set(["galacticapes", "pixeldoges", "daoduckgenesis", "custombayc", "mocaversehonourarymocas", "dininhoopenstore"]);
  const idsToExcludeHidden = new Set(["phunks", "timelesscharacters", "cryptopunks", "chainrunners", "larvalads", "averagepunks", "elderglade"]);

  const filteredAvatars = avatars
    .filter(
      (avatar) => (blockchainFilter === "all" || avatar.chain === blockchainFilter) && !idsToExcludeOld.has(avatar.id) && !idsToExcludeHidden.has(avatar.id)
    )
    .map((avatar) => ({
      id: avatar.id,
      _id: avatar._id,
      customName: avatarMap.find((a) => a.id === avatar.id)?.customName || avatar.customName || avatar.id,
      image: avatarMap.find((a) => a.id === avatar.id)?.image || "",
    }))
    .sort((a, b) => a.customName.toLowerCase().localeCompare(b.customName.toLowerCase()));

  // Generate dropdown options
  const avatarOptions = filteredAvatars.map((avatar) => ({
    value: avatar._id,
    label: avatar.customName,
  }));

  // Show only selected avatar if chosen, otherwise show all
  const displayedAvatars = selectedAvatar ? filteredAvatars.filter((avatar) => avatar._id === selectedAvatar._id) : filteredAvatars;

  useEffect(() => {
    const fetchAvatars = async () => {
      try {
        const response = await axios.get("https://api.pixelore.wiki/api/avatars");
        setAvatars(response.data);
      } catch (err) {
        setError("Error fetching avatars");
        console.error(err);
      }
    };

    fetchAvatars();
  }, []);

  useEffect(() => {
    if (gifs && Object.keys(gifs).length > 0) {
      const fetchBlobs = async () => {
        const newDownloadLinks = await Promise.all(
          Object.entries(gifs).map(async ([name, url]) => {
            try {
              const response = await fetch(url); // Fetch the GIF
              const blob = await response.blob(); // Convert to Blob
              const blobUrl = URL.createObjectURL(blob); // Create Blob URL

              return (
                <button
                  key={name}
                  onClick={() => {
                    const a = document.createElement("a");
                    a.href = blobUrl;
                    a.download = `${name}.gif`;
                    a.click();
                    URL.revokeObjectURL(blobUrl); // Cleanup
                  }}
                  className="m-1 h-6 px-2 text-xs panel-button flex items-center justify-center"
                >
                  {name}
                </button>
              );
            } catch (error) {
              console.error(`Failed to fetch blob for ${name}:`, error);
              return null;
            }
          })
        );

        setDownloadLinks(newDownloadLinks.filter(Boolean)); // Remove null values
      };

      fetchBlobs();
    }
  }, [gifs]);

  const blockchainOptions = [
    { value: "all", label: "All Chains" },
    { value: "ethereum", label: "Ethereum" },
    { value: "matic", label: "Polygon" },
    { value: "ronin", label: "Ronin" },
  ];

  return (
    <div className="panel-style text-[var(--text-color)] w-full">
      <h1 className="panel-heading">Avatars</h1>
      <div className="text-xs">
        <i className="fa-solid fa-wand-magic-sparkles" /> Latest: {avatarNames}
      </div>
      <div className="flex sm:flex-row flex-col w-full md:gap-4 lg:gap-8">
        {/* Avatar List on Left */}
        <div className="lg:w-2/5 md:w-1/2 w-1/4 max-h-[600px] sm:border-r border-gray-700 p-4">
          <div className="w-full text-xs text-[var(--text1-color)] mb-2">
            <form onSubmit={handleGenerateClick} className="w-full flex flex-wrap items-center gap-2 sm:flex-col md:flex-row">
              {/* Dropdown for Filtering */}
              <Select
                id="blockchain-filter"
                className="select-forms"
                styles={{
                  control: (base) => ({
                    ...base,
                    height: "32px", // Matches h-8 (Tailwind's 2rem)
                    minHeight: "32px",
                    width: "80px",
                  }),
                }}
                value={{
                  value: blockchainFilter,
                  label: blockchainOptions.find((option) => option.value === blockchainFilter)?.label,
                }}
                onChange={(selected) => setBlockchainFilter(selected.value)}
                options={blockchainOptions}
              />

              {/* Avatar Selection Dropdown */}
              <Select
                id="avatar-select"
                className="select-forms"
                styles={{
                  control: (base) => ({
                    ...base,
                    height: "32px",
                    minHeight: "32px",
                    width: "150px",
                  }),
                }}
                value={selectedAvatar ? { value: selectedAvatar._id, label: selectedAvatar.customName } : null}
                onChange={(selected) => {
                  if (!selected) {
                    setSelectedAvatar(null); // Clearing should restore all avatars
                  } else {
                    const avatar = filteredAvatars.find((a) => a._id === selected.value);
                    setSelectedAvatar(avatar || null);
                  }
                }}
                options={avatarOptions}
                isSearchable
                placeholder="Select.."
                isClearable
              />

              {/* Avatar ID Number Text */}
              <input type="text" placeholder="ID" value={tokenNum} onChange={(e) => setTokenNum(e.target.value)} className="select-forms w-12 h-8 mr-1 px-2 " />

              {/* Generate GIF Button */}
              <button type="submit" className="panel-button h-8">
                Generate
              </button>
            </form>
          </div>

          {/* Avatar Grid - Shows All by Default, Filters on Selection */}
          <div className="hidden sm:grid md:grid-cols-3 lg:grid-cols-4 gap-1 overflow-y-auto max-h-[calc(100%-2rem)]">
            {displayedAvatars.map((avatar) => (
              <div
                key={avatar.id}
                className={`component-style p-2 border rounded cursor-pointer ${selectedAvatar?._id === avatar._id ? "border-retropink" : "border-gray-600"}`}
                onClick={() => setSelectedAvatar(avatar)}
              >
                <img src={avatar.image} alt={avatar.customName} className="w-24 h-24 mx-auto object-cover" />
                <p className="text-xs text-center font-semibold">{avatar.customName}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Section */}
        <div className="w-full sm:w-3/5 p-2 text-center">
          {error && <p className="text-red-500 mt-4">{error}</p>}
          {!loading && !avatarInfo && <div className="md:text-base text-xs">Select Avatar Information</div>}

          {loading ? (
            <LoadingSpinner />
          ) : (
            <div className="">
              {combinedImageUrl && (
                <div className="component-style w-full">
                  <div>
                    <h2 className="panel-heading text-center text-3xl">Sprite</h2>
                    <img src={combinedImageUrl} alt="Sprite" className="scale-150 inline-block" />
                  </div>

                  <div className="flex flex-wrap justify-center gap-4 mt-6">
                    {Object.keys(gifs).map((animationName) => (
                      <div key={animationName} className="gif-item text-center">
                        <h2 className="text-lg">{animationName}</h2>
                        <div className="gif-box">
                          <img src={gifs[animationName]} alt={`${animationName} GIF`} />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-4 flex flex-row justify-center">{downloadLinks}</div>
                </div>
              )}

              {avatarInfo && (
                <div className="component-style border-2 rounded-lg shadow-lg p-4 mx-auto">
                  <h2 className="panel-heading text-2xl text-center">Avatar Info</h2>
                  <div className="text-sm" dangerouslySetInnerHTML={{ __html: avatarInfo }} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Avatars;
